import { render, staticRenderFns } from "./readmissionsModal.vue?vue&type=template&id=6c73ac57"
import script from "./readmissionsModal.vue?vue&type=script&lang=js"
export * from "./readmissionsModal.vue?vue&type=script&lang=js"
import style0 from "./readmissionsModal.vue?vue&type=style&index=0&id=6c73ac57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports